import React from 'react';

import SettingsPage from '../../components/settings/SettingsPage';
import CacheInvalidateButtons from '../../components/settings/CacheInvalidateButtons';
import WrapperSection from '../../components/global/WrapperSection';

// Sections explicitly declare expected field keys via `defaultFields` so
// the admin can fill them even when the backend hasn't seeded them yet.
// Empty-string defaults are skipped on save (buildPatch diffs against
// the original — untouched defaults never reach the API).
const sections = [
    {
        key: 'integrations',
        titleEn: 'Integrations',
        titleAr: 'التكاملات',
        descriptionEn: 'Third-party services connected to the store.',
        descriptionAr: 'الخدمات الخارجية المربوطة بالمتجر.',
        alwaysShow: true,
        defaultFields: {
            google_analytics_id: '',
            facebook_pixel_id: '',
            tap_marketing_tag: '',
        },
        fieldOrder: ['google_analytics_id', 'facebook_pixel_id', 'tap_marketing_tag'],
    },
    {
        key: 'social',
        titleEn: 'Social',
        titleAr: 'الشبكات الاجتماعية',
        descriptionEn: 'Public links shown on the storefront footer.',
        descriptionAr: 'الروابط العامة الظاهرة في تذييل الموقع.',
        alwaysShow: true,
        defaultFields: {
            facebook: '',
            instagram: '',
            twitter: '',
            tiktok: '',
        },
        fieldOrder: ['facebook', 'instagram', 'twitter', 'tiktok'],
    },
];

const IntegrationsSettings = () => (
    <>
        <SettingsPage
            titleEn="Integrations"
            titleAr="التكاملات"
            descriptionEn="Connect analytics, SMS, WhatsApp and shipping providers. After saving, invalidate the storefront cache so changes propagate."
            descriptionAr="ربط التحليلات والرسائل النصية وواتساب ومزوّدي الشحن. بعد الحفظ، فرّغ كاش الواجهة الأمامية حتى تظهر التغييرات للزائرين."
            sections={sections}
        />
        <WrapperSection>
            <CacheInvalidateButtons />
        </WrapperSection>
    </>
);

export default IntegrationsSettings;
